import Choices from "choices.js";

export function dropdownInput() {

    let dropdownFields = document.querySelectorAll('[data-dropdownField]');

    dropdownFields.forEach(dropdown => {
        const options = dropdown.querySelectorAll('option');
        dropdown.defaultOptions = [];
        options.forEach(option => {
            const selected = option.hasAttribute('selected');
            dropdown.defaultOptions.push({
                value: option.value,
                text: option.textContent,
                selected: selected,
                dataset: option.dataset
            });
            if(selected) {
                dropdown.value = option.value;
            }
        });
        dropdown.defaultDataset = dropdown.dataset;
        dropdown.choices = new Choices(dropdown, {
            searchEnabled: false,
            allowHTML: false,
            placeholder: true,
            shouldSort: false
        });
        if(dropdown.hasAttribute('data-convert-input')) {
            const targetInputSelector = dropdown.getAttribute('data-convert-input');
            const targetInput = document.querySelector(targetInputSelector);
            let previousUnit = dropdown.value;
            dropdown.addEventListener('change', function (evt) {
                const newUnit = evt.target.value;
                let currentValue = parseFloat(targetInput.value) || 0;
                if (currentValue % 1 === 0) {
                    currentValue = parseInt(currentValue.toString(), 10);
                }
                const conversionData = JSON.parse(dropdown.getAttribute("data-conversions"));
                if (
                    typeof conversionData[previousUnit] !== 'undefined'
                ) {
                    if(typeof conversionData[previousUnit][newUnit] !== 'undefined') {
                        const conversionRate =
                            conversionData[previousUnit][newUnit];
                        let convertedValue = (currentValue * conversionRate).toFixed(2);

                        if (conversionData[newUnit]?.step % 1 === 0) {
                            convertedValue = Math.round(convertedValue);
                        } else if (convertedValue % 1 === 0) {
                            convertedValue = parseInt(convertedValue, 10);
                        }

                        if (conversionData[newUnit]['min'] && parseFloat(convertedValue)<parseFloat(conversionData[newUnit]['min'])) {
                            convertedValue = conversionData[newUnit]['min'];
                        }

                        if (conversionData[newUnit]['max'] && parseFloat(convertedValue)>parseFloat(conversionData[newUnit]['max'])) {
                            convertedValue = conversionData[newUnit]['max'];
                        }

                        targetInput.value = convertedValue;
                    } else if(
                        typeof conversionData[previousUnit]['values'] !== 'undefined' &&
                        typeof conversionData[previousUnit]['values'][currentValue] !== 'undefined' &&
                        typeof conversionData[previousUnit]['values'][currentValue][newUnit] !== 'undefined'
                    ) {
                        targetInput.value = conversionData[previousUnit]['values'][currentValue][newUnit];
                    } else {
                        targetInput.value = '';
                    }
                } else {
                    targetInput.value = '';
                }
                if (conversionData[newUnit]['step']) {
                    targetInput.setAttribute('step', conversionData[newUnit]['step']);
                }
                if (conversionData[newUnit]['min']) {
                    targetInput.setAttribute('min', conversionData[newUnit]['min']);
                }
                if (conversionData[newUnit]['max']) {
                    targetInput.setAttribute('max', conversionData[newUnit]['max']);
                }
                previousUnit = newUnit;
                if ("createEvent" in document) {
                    let evt = document.createEvent("HTMLEvents");
                    evt.initEvent('change', false, true);
                    targetInput.dispatchEvent(evt);
                }
                else
                    targetInput.fireEvent("on"+'change');
            });
        }
    })

}
